export default __webpack_public_path__ + "static/media/BTC.6e8524ff.jpg";